import { ROUTES } from 'config';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { downgray2 } from 'static/icons/resizable';
import * as S from './BreadcrumbsNavigation.styles';

type Destination = {
  to: (typeof ROUTES)[keyof typeof ROUTES];
  title: string;
};

type BreadcrumbsNavigationProps = {
  destinations: Destination[];
};

export const BreadcrumbsNavigation = memo(
  ({ destinations }: BreadcrumbsNavigationProps) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    return (
      <S.BreadcrumbsWrapper>
        <S.BreadcrumbLink to={ROUTES.main}>
          {t('mainPage.title')}
        </S.BreadcrumbLink>

        {destinations.map((destination) => (
          <React.Fragment key={destination.to}>
            <S.BackLinkIcon src={downgray2} />

            <S.BreadcrumbLink
              $isActive={destination.to === pathname}
              to={destination.to}
            >
              {destination.title}
            </S.BreadcrumbLink>
          </React.Fragment>
        ))}
      </S.BreadcrumbsWrapper>
    );
  },
);
